module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/Waterford-03ce071c5012d48ed3b3d7878aaa8048.png";